<div>
  @if (this.errorMessage) {
    <div style="color: red; font-size: large; text-align: center">
      {{ errorMessage }}
    </div>
  }
  <nz-spin [nzSpinning]="isLoading">
    <div #graphContainer class="responsive-container">
      <svg #graph></svg>
    </div>
  </nz-spin>
</div>